import React from "react";
import Slider from "react-slick";

const CarouselReviewsWidget = (props: any) => {
  const NextArrow = (props: any) => {
    const { onClick, ...otherProps } = props;
    return (
      <div onClick={() => onClick()}>
        <i className="fas fa-chevron-right fa-xs right-arrow-icon" aria-hidden="true"></i>
      </div>
    );
  };

  const PrevArrow = (props: any) => {
    const { onClick, ...otherProps } = props;
    return (
      <div onClick={() => onClick()}>
        <i className="fas fa-chevron-left fa-xs right-arrow-icon" aria-hidden="true"></i>
      </div>
    );
  };

  var settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    // slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };
  return (
    <React.Fragment>
      <div className="product-review-widgt">
        <Slider {...settings}>
          {props.data.map((item: any, i: any) => {
            return (
              <div key={i} className="carousel-col-review">
                <div className="review-container-slider">
                  <div className={`review-title`}>{item.Review}</div>
                  <h5 className="review-description">
                    <span className="reviewer-name">{item.CustomerName}</span>{" "}
                    {item.CustomerLocation}
                  </h5>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </React.Fragment>
  );
};

export default CarouselReviewsWidget;
